import React from "react";
import "../styles/FiltersMenu.css";
import { PLUS } from "../helpers/subscriptionTiers";
import { useUI, useUser, useFilters, useMenu } from "../hooks/index.js";
import ProjectBreadcrumb from "./ProjectBreadcrumb";

const FiltersMenu = ({ loggedIn }) => {
  const { isMobile } = useUI();
  const { subscriptionTier } = useUser();
  const {
    showSubscriptionMenu,
    setShowSubscriptionMenu,
    setOverlayContent,
    filtersMenuTemporaryVisible,
  } = useMenu();
  const {
    activeSlate,
    showCompleted,
    setShowCompleted,
    completedFilter,
    setCompletedFilter,
    handleSlateChange,
    slates,
  } = useFilters();

  if (!loggedIn) return null;
  if (showSubscriptionMenu) return null;

  const shouldBeVisible = isMobile || filtersMenuTemporaryVisible;

  return (
    <div
      className={`flex filters-menu ${isMobile ? "flex-col" : ""} ${
        shouldBeVisible ? "always-visible" : ""
      }`}
    >
      {subscriptionTier >= PLUS ? (
        <div className="flex">
          <div className="slate-selector">
            <button onClick={() => handleSlateChange("prev")}>&lt;</button>
            <span className="slate-name">{slates[activeSlate]}</span>
            <button onClick={() => handleSlateChange("next")}>&gt;</button>
          </div>

          <ProjectBreadcrumb />
        </div>
      ) : (
        <div className="slate-selector upgrade-prompt">
          <button disabled title="Subscribe to unlock additional slates">
            &lt;
          </button>
          <span
            className="slate-name upgrade-link"
            onClick={() => setShowSubscriptionMenu(true)}
            title="Subscribe to unlock additional slates"
          >
            {slates[activeSlate]} (Subscribe for more slates)
          </span>
          <button disabled title="Subscribe to unlock additional slates">
            &gt;
          </button>
        </div>
      )}

      {!isMobile && (
        <div className={`filters-buttons ${isMobile ? "mt-2" : ""}`}>
          <button
            className={`filter-btn pending-btn ${
              !showCompleted ? "active" : ""
            }`}
            onClick={() => setShowCompleted(false)}
          >
            Pending
          </button>
          <button
            className={`filter-btn completed-btn ${
              showCompleted ? "active" : ""
            }`}
            onClick={() => setShowCompleted(true)}
          >
            Completed
          </button>
          <select
            value={completedFilter}
            onChange={(e) => setCompletedFilter(e.target.value)}
            className={`completed-filter-dropdown ${
              !showCompleted ? "hidden" : ""
            }`}
          >
            <option value="today">Today</option>
            <option value="thisWeek">This Week</option>
          </select>
          <button
            className="filter-btn export-btn"
            onClick={() => setOverlayContent("exportTasks")}
            title="Export tasks to CSV"
          >
            Export
          </button>
        </div>
      )}
    </div>
  );
};

export default FiltersMenu;
